import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { execute, gql } from '~/services-v2/financial-bff/financial-bff-gql'

const GQL = gql(`
  mutation InstallationPowerInvertersValidate($input: ValidateTotalInvertersPowerInput!) {
    installation_power_inverters_validate(input: $input) {
      is_valid
      error
    }
  }
`)

export default function useInstallationPowerInvertersValidate(projectId: Ref<string>, power: Ref<number | undefined | null>) {
  const queryKey = ref(queryKeys.INSTALLATION.VALIDATE_TOTAL_INVERTERS_POWER(projectId.value, power.value ?? 0))

  const queryFn = async () => {
    const res = await execute(GQL, {
      input: {
        project_id: projectId.value,
        total_inverters_power_kw: power.value ?? 0,
      },
    })

    return res.installation_power_inverters_validate
  }

  const query = useQuery({
    queryKey,
    queryFn,
    enabled: !!projectId.value && !!power.value,
  })

  watch([projectId, power], () => {
    queryKey.value = queryKeys.INSTALLATION.VALIDATE_TOTAL_INVERTERS_POWER(projectId.value, power.value ?? 0)
    query.refetch()
  })

  return query
}
